/**
 * @file 基于 antd 二次封装的基础组件中，用于合并二次封装的组件内部样式跟外部传入的样式
 */
import type React from 'react';

export type SemanticStylesObject = Record<string, React.CSSProperties | undefined>;

export type SemanticStylesValue<S extends SemanticStylesObject, P> =
    | Partial<S>
    | ((info: {props: P}) => Partial<S>)
    | undefined;

export function mergeSemanticStyles<S extends SemanticStylesObject, P = unknown>(
    ...sources: Array<SemanticStylesValue<S, P>>
): (info: {props: P}) => S {
    return (info) => {
        const merged: Record<string, React.CSSProperties> = {};
        for (const src of sources) {
            if (!src) {
                continue;
            }
            const obj = typeof src === 'function' ? src(info) : src;
            if (!obj) {
                continue;
            }
            for (const key of Object.keys(obj)) {
                const value = obj[key];
                if (value) {
                    merged[key] = {...merged[key], ...value};
                }
            }
        }
        return merged as S;
    };
}
